import { IIconProps } from "../types"

export default function IconUR2(props: IIconProps) {
  const width = props.size || props.width || 65
  const height = props.size || props.height || 89
  return (
    <svg
      {...props}
      width={width}
      height={height}
      className={props.className}
      style={props.style}
      viewBox="0 0 65 89"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.5642 0.814245C35.5442 0.974245 37.6342 1.43424 39.5242 2.47424C41.4042 3.51424 43.1042 5.14424 44.6642 7.22424C46.2242 9.31424 47.6542 11.8442 50.3542 20.2842C53.0642 28.7142 57.0342 43.0342 59.3442 52.2142C61.6542 61.3942 62.3042 65.4342 62.7642 68.8142C63.2142 72.2042 63.4742 74.9342 63.1542 77.2842C62.8242 79.6242 61.9142 81.5742 60.6142 83.1042C59.3142 84.6342 57.6142 85.7442 55.0142 86.4942C52.4042 87.2442 48.8942 87.6342 43.2942 87.7942C37.6942 87.9542 30.0142 87.8942 24.3842 87.4042C18.7542 86.9142 15.1742 86.0042 12.2442 84.8642C9.31419 83.7242 7.03419 82.3542 5.40419 80.7342C3.77419 79.1042 2.80419 77.2142 2.11419 75.5842C1.43419 73.9642 1.04419 72.5942 0.844193 70.8342C0.654193 69.0742 0.654193 66.9242 1.79419 60.6142C2.93419 54.2942 5.20419 43.8142 7.65419 35.0942C10.0942 26.3642 12.6942 19.4042 15.1042 14.4542C17.5142 9.50424 19.7242 6.57424 21.8142 4.65424C23.8942 2.73424 25.8442 1.82424 27.7642 1.30424C29.6842 0.784245 31.5742 0.654245 33.5642 0.814245Z"
        fill="#E6E6E6"
        stroke="black"
        strokeWidth="1.5"
        strokeMiterlimit="2.61313"
      />
    </svg>
  )
}
